import React, { useState } from 'react'
import useAuth from '../context/userContext'
import DashboardHeader from '../components/DashboardHeader'
import { FiPlusCircle } from 'react-icons/fi'
import { MdOutlineEmail } from 'react-icons/md'
import PermissionsTab from '../components/activity-users/PermissionsTab'
import TeamMembersTab from '../components/activity-users/TeamMembersTab'

const ActivityUsersView = () => {
  const { permissions } = useAuth()
  const [activeTab, setActiveTab] = useState('teamMembers')
  const [showCreateRoleModal, setShowCreateRoleModal] = useState(false)

  // Team Members tab states
  const [inviteModal, setInviteModal] = useState(false)
  const [editRoleModal, setEditRoleModal] = useState(false)
  const [selectedTeam, setSelectedTeam] = useState(null)

  const canCreateUsers = permissions?.capabilities?.canCreateUsers ||
    permissions?.capabilities?.canCreateProgramOfficers ||
    permissions?.capabilities?.canCreateFieldOfficers ||
    permissions?.isServiceProvider ||
    permissions?.isProcessor

  return (
    <div className="w-full lg:px-10 px-2 h-full py-10">
      <div className="w-full space-y-6">
        {/* DASHBOARD HEADER */}
        <div className="flex flex-col gap-5 lg:flex-row lg:items-center lg:justify-between md:flex-row md:items-center md:justify-between mb-4">
          <DashboardHeader label="User management" />
          {activeTab === 'permissions' && canCreateUsers && (
            <button
              onClick={() => setShowCreateRoleModal(true)}
              className="bg-yellowcolor hover:bg-yellowcolor/80 text-black px-6 flex flex-row items-center gap-2 py-2 capitalize rounded-md"
            >
              <FiPlusCircle size={20} />
              Create Roles
            </button>
          )}
          {activeTab === 'teamMembers' && canCreateUsers && (
            <button
              onClick={() => setInviteModal(true)}
              className="h-10 px-5 bg-yellowcolor hover:bg-yellowcolor/80 text-black text-sm rounded-lg flex items-center gap-2"
            >
              <MdOutlineEmail className="h-5 w-5" />
              Send New Invites
            </button>
          )}
        </div>

        {/* Tabs */}
        <div className='border-b border-gray-200 dark:border-border-dark w-full'>
          <button
            onClick={() => setActiveTab('teamMembers')}
            className={`px-4 border-b-2 pb-3 text-base transition-all duration-300 ${activeTab === 'teamMembers'
                ? 'text-yellowcolor border-yellowcolor'
                : 'text-gray-700 dark:text-white border-transparent'
              }`}
          >
            Team Members
          </button>
          <button
            onClick={() => setActiveTab('permissions')}
            className={`px-4 border-b-2 pb-3 text-base transition-all duration-300 mr-4 ${activeTab === 'permissions'
                ? 'text-yellowcolor border-yellowcolor'
                : 'text-gray-700 dark:text-white border-transparent'
              }`}
          >
            User Roles
          </button>
        </div>

        {/* Tab Content */}
        {activeTab === 'teamMembers' && (
          <TeamMembersTab
            inviteModal={inviteModal}
            setInviteModal={setInviteModal}
            editRoleModal={editRoleModal}
            setEditRoleModal={setEditRoleModal}
            selectedTeam={selectedTeam}
            setSelectedTeam={setSelectedTeam}
          />
        )}
        
        {activeTab === 'permissions' && (
          <PermissionsTab createModalOpen={showCreateRoleModal} setCreateModalOpen={setShowCreateRoleModal} />
        )}

      </div>
    </div>
  )
}

export default ActivityUsersView